import { takeLatest, takeEvery, all, put } from 'redux-saga/effects'
import * as calls from './calls'
import * as reducerActions from '../../reducers/catalogoReducer/actions'
import * as reducerActionsPedidos from '../../reducers/pedidosReducer/actions'
import * as layoutActions from '../../reducers/layoutReducer/actions'
import * as Notifications from '../../components/Common/notification'


function* genSaveCatalogo(e){
    try {

        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Guardando catálogo' }))

        let payload = {
            ...e.payload
        }
        payload.callback = undefined
        
        // llamo a la acción que guarda el catálogo
        let idCatalogo =  yield calls.saveCatalogo(e.payload)
        yield put(reducerActions.setIdCatalogo(idCatalogo))
       
        // almaceno los datos en el estado del reductor
        //yield put(testReducerActions.setTestData(testData))
        //Payload recibe una callback para asegurarse de que se haya guardado el catalogo, y actualiza el state
        e.payload.callback(idCatalogo)
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
        
        if (e.payload.Id === 0){
            Notifications.showSuccess("Catálogo Creado")
        }else{
            Notifications.showSuccess("Catálogo Editado")
        }
    }
}

function* genSaveImagenCatalogo(e){
    try {

        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Subiendo imagen' }))

        // llamo a la acción que guarda el catálogo
        yield calls.saveImagenCatalogo(e.payload)
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}



function* genSaveImagenCatalogoToTemp(e){ //Exclusivo para la edición de Catalogos.
    try {

        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Subiendo imagen' }))

        // llamo a la acción que guarda el catálogo
        yield calls.saveImagenCatalogoATemp(e.payload)
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}


function* genGetCatalogoByName(e){
    try {
        // muestro el loader
        if (e.payload.showLoading)
            yield put(layoutActions.setLoading({ showloadingcatalogo: true, message: 'Obteniendo catálogos' }))

        // llamo a la acción que trae el catálogo
        let catalogos = yield calls.getCatalogoByName(e.payload)
        yield put(reducerActions.setCatalogos(catalogos))
        
        if (catalogos.length === 0) 
        Notifications.showError("No se encontraron catálogos activos.")
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        if (e.payload.showLoading)
            yield put(layoutActions.setLoading({ showloadingcatalogo: false }))
    }
}

function* genGetCatalogoImagen(e){
    try {

        
        let payload = {...e.payload}
        payload.callback = undefined
        // llamo a la acción que trae el catálogo
        let imagen = yield calls.getCatalogoImagen(e.payload)
        
        // actualizo el array de imágenes de catálogo
        let imagenCatalogo = {
            idCatalogo: payload.idCatalogo,
            imagen: imagen
        }
        e.payload.callback()
        
        yield put(reducerActions.setImagenCatalogo(imagenCatalogo))

        
    }
    catch (e) 
    {
    }
}

function* genGetCatalogoCompleto(e){
    try {
        yield put(reducerActions.setCatalogoCompleto(undefined))

        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Recuperando catálogo' }))
       
        // llamo a la acción que trae el catálogo
        let catalogo = yield calls.getCatalogoCompleto(e.payload)
        yield put(reducerActions.setCatalogoCompleto(catalogo))
        
        
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* genGetCatalogoCompletoAuxiliar(e){
    try {
        yield put(reducerActions.setCatalogoCompletoAuxiliar(undefined))

        
        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Recuperando catálogo' }))
       
        // llamo a la acción que trae el catálogo
        let catalogo = yield calls.getCatalogoCompleto(e.payload)
        
        yield put(reducerActions.setCatalogoCompletoAuxiliar(catalogo))
        
        
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}



function* genGetArticuloImagenes(e){
    try {

        // llamo a la acción que trae las imágenes de un artículo
        let imagenesArticulo = yield calls.getArticuloImagenes(e.payload)

        // actualizo el array de imágenes de catálogo
        let item = {
            idArticulo: e.payload.idArticulo,
            imagenes: imagenesArticulo
        }

    
        yield put(reducerActions.setImagenesArticulo(item))
    }
    catch (e) 
    {
    }
}

function* genGetPublicados(e){
    try {
        let catalogos = yield calls.getPublicados()
        yield put(reducerActions.setPublicados(catalogos))
        if(catalogos[0]){
        yield put(reducerActionsPedidos.sagaGetResumenPedidos(catalogos[0].idCatalogo))
        }
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
}

function* genSavePublicarCatalogo(e){
    try {
     
        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Publicando catálogo' }))
        
        // llamo a la acción que guarda el catálogo
        let payload = {
            id : e.payload.id
        }
        yield calls.savePublicarCatalogo(payload)
        
        //llamo a la funcion callback para mostrar el mensaje
        e.payload.showMenssageInfo()
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* genSaveOcultarCatalogo(e){
    try {
       
        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Ocultando catálogo' }))

        // llamo a la acción que guarda el catálogo
        yield calls.saveOcultarCatalogo(e.payload) 
      
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* genCambiarOrdenEntradaCatalogo(e){
    try {
       
        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Cambiando órden' }))

        // llamo a la acción que guarda el catálogo
        yield calls.saveCambiarOrdenEntradaCatalogo(e.payload) 
      
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
        Notifications.showSuccess("Orden cambiado correctamente")
    }
}

function* genSaveTrasladarCatalogo(e){
    try {

        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Trasladando catálogo' }))

        let payload = {idCatalogoDesde: e.payload.idCatalogoDesde, idCatalogoHasta: e.payload.idCatalogoHasta}
        // llamo a la acción que guarda el catálogo
        yield calls.saveTrasladarCatalogo(payload)
        
        e.payload.callback()
      
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* genSaveBorrarCatalogo(e){
    try {

        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Borrando catálogo' }))

        let payload = {id: e.payload.id}
        // llamo a la acción que guarda el catálogo
        yield calls.saveBorrarCatalogo(payload) 
        e.payload.callback()
      
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* defaultSaga() {
    yield all([
      takeLatest(reducerActions.SAGA_SAVE_CATALOGO, genSaveCatalogo),
      takeLatest(reducerActions.SAGA_GET_CATALOGO_NAME, genGetCatalogoByName),
      takeLatest(reducerActions.SAGA_GET_PUBLICADOS, genGetPublicados),
      takeLatest(reducerActions.SAGA_SAVE_PUBLICAR_CATALOGO, genSavePublicarCatalogo),
      takeLatest(reducerActions.SAGA_SAVE_OCULTAR_CATALOGO, genSaveOcultarCatalogo),
      takeLatest(reducerActions.SAGA_SAVE_BORRAR_CATALOGO, genSaveBorrarCatalogo),
      takeLatest(reducerActions.SAGA_GET_CATALOGO_COMPLETO_ID, genGetCatalogoCompleto),
      takeLatest(reducerActions.SAGA_SAVE_CATALOGO_IMAGEN, genSaveImagenCatalogo),
      takeLatest(reducerActions.SAGA_TRASLADAR_CATALOGO, genSaveTrasladarCatalogo),
      takeEvery(reducerActions.SAGA_GET_IMAGEN_CATALOGO, genGetCatalogoImagen),
      takeEvery(reducerActions.SAGA_SAVE_IMAGEN_CATALOGO_TEMPORAL, genSaveImagenCatalogoToTemp),
      takeEvery(reducerActions.SAGA_GET_IMAGENES_ARTICULO, genGetArticuloImagenes),
      takeEvery(reducerActions.SAGA_CAMBIAR_ORDEN_CATALOGO_ENTRADA, genCambiarOrdenEntradaCatalogo),
      takeLatest(reducerActions.SAGA_GET_CATALOGO_COMPLETO_AUXILIAR, genGetCatalogoCompletoAuxiliar)  
    ])
  }
  
  export const sagas = [
    defaultSaga
  ]